import { z } from 'zod'
import { HexNumber } from '@lukso/controllerapps-sharedlogic-primitives'

import { PostDeploymentModuleCalldata } from '../../../cross-chain-deployment/PostDeploymentModuleCalldata'

export const PostDeploymentModuleCalldataSchema = z.string()

type PostDeploymentModuleCalldataReportText = z.infer<
  typeof PostDeploymentModuleCalldataSchema
>

export function mapDomainToReportText(
  postDeploymentModule: PostDeploymentModuleCalldata
): PostDeploymentModuleCalldataReportText {
  return postDeploymentModule.getValue().getValue()
}

export function mapReportTextToDomain(
  reportText: PostDeploymentModuleCalldataReportText
): PostDeploymentModuleCalldata {
  return PostDeploymentModuleCalldata.create({
    postDeploymentModuleCalldataValue: HexNumber.create({
      hexNumberValue: reportText,
    }),
  })
}
